export default "__VITE_ASSET__CycH37sg__"